import { Dinero, greaterThanOrEqual, isPositive, isZero } from 'dinero.js';

const hasPositiveValue = (amount: Dinero<number>): boolean => {
  return isPositive(amount) && !isZero(amount);
};

export const getPreviousMembershipCreditsUsed = ({
  unusedAmount,
  creditIssued,
  membershipPrice,
  proratedPrice,
}: {
  unusedAmount: Dinero<number>;
  creditIssued: Dinero<number>;
  membershipPrice: Dinero<number>;
  proratedPrice?: Dinero<number> | null;
}): Dinero<number> => {
  if (hasPositiveValue(creditIssued)) {
    return proratedPrice || membershipPrice;
  }

  if (proratedPrice) {
    return greaterThanOrEqual(unusedAmount, proratedPrice)
      ? proratedPrice
      : unusedAmount;
  }

  return greaterThanOrEqual(unusedAmount, membershipPrice)
    ? membershipPrice
    : unusedAmount;
};
